// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3EnOt","error":"Textarea_error__2O3Xw","readonly":"Textarea_readonly__s9fve","disabled":"Textarea_disabled__j_-c4"};